@if (!isErrorsOpen()) {
    <button
        class="errors-toggle-button"
        type="button"
        (click)="toggleErrors()">
        <fa-icon [icon]="['fas', 'triangle-exclamation']" />
        <span> {{ 'error' | transloco: { COUNT: errors().length } }} ({{ errors().length }}) </span>
    </button>
} @else {
    <div class="errors-panel">
        <div
            class="flex items-center gap-2 cursor-pointer"
            (click)="toggleErrors()">
            <fa-icon
                class="cursor-pointer text-secondary transition-colors hover:text-primary"
                size="lg"
                [icon]="['far', 'arrow-left']" />
            <h2 class="!m-0 text-lg !font-medium">
                {{ 'error' | transloco: { COUNT: errors().length } }} ({{ errors().length }})
            </h2>
        </div>

        @if (errors().length) {
            <div class="flex max-h-80 flex-col gap-3 overflow-auto overflow-x-hidden">
                @for (error of errors(); track error) {
                    <div>
                        <p class="m-0 font-medium">
                            {{ 'errorIndex' | transloco: { INDEX: $index + 1 } }}
                        </p>
                        <p class="m-0">{{ error }}</p>
                    </div>
                }
            </div>
        }
    </div>
}
